import { Check } from "lucide-react";

import { Button } from "@design-lab/shared/ui/design-system/Button";

type PinEscalationCardProps = {
  onConfirm: () => void;
  onCancel: () => void;
  isConfirming: boolean;
  isCancelling: boolean;
  compact?: boolean;
};

export function PinEscalationCard({
  onConfirm,
  onCancel,
  isConfirming,
  isCancelling,
  compact = false
}: PinEscalationCardProps) {
  const isDisabled = isConfirming || isCancelling;
  return (
    <div
      className={`rounded-lg border-[1.5px] border-gray-200 bg-gray-100 ${compact ? "p-2" : "p-3"}`}
      data-testid="pinning-escalation-card"
    >
      <div className="flex items-center gap-2">
        <p className="text-[10px] font-bold uppercase tracking-wide text-gray-900">
          Professional edit required
        </p>
        <span className="rounded-full bg-[#00834F] px-1.5 py-0.5 text-xs font-medium text-white">
          Free
        </span>
      </div>
      <p className={`mt-1 text-gray-900 ${compact ? "text-xs" : "text-sm"}`}>
        Our artists will handle this after checkout.
      </p>
      <div className={`flex gap-2 ${compact ? "mt-2" : "mt-3"}`}>
        <Button
          data-testid="pinning-escalation-cancel"
          variant="outline"
          size="sm"
          className={compact ? "flex-1 bg-white" : "bg-white px-3.5"}
          onPress={onCancel}
          isDisabled={isDisabled}
        >
          {isCancelling ? "Cancelling\u2026" : "No, discard request"}
        </Button>
        <Button
          data-testid="pinning-escalation-confirm"
          size="sm"
          className={
            compact
              ? "flex-1 bg-[#00834F] text-white hover:bg-[#006B40]"
              : "bg-[#00834F] px-3.5 text-white hover:bg-[#006B40]"
          }
          onPress={onConfirm}
          isDisabled={isDisabled}
        >
          <Check className="h-4 w-4" />
          {isConfirming ? "Sending\u2026" : "Yes, Send to Artist"}
        </Button>
      </div>
    </div>
  );
}
